import { render, staticRenderFns } from "./HistoricalAanalysis.vue?vue&type=template&id=792ff57a&scoped=true"
import script from "./HistoricalAanalysis.vue?vue&type=script&lang=js"
export * from "./HistoricalAanalysis.vue?vue&type=script&lang=js"
import style0 from "./HistoricalAanalysis.vue?vue&type=style&index=0&id=792ff57a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ff57a",
  null
  
)

export default component.exports